import { render, staticRenderFns } from "./ActionSendInvoice.vue?vue&type=template&id=6b0dd7f6&lang=html"
import script from "./ActionSendInvoice.vue?vue&type=script&lang=js"
export * from "./ActionSendInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports